export const DEFAULT_IMAGE_EXTENSION = '.jpg';
export const XXL_SUFFIX = '_xxl-1';
export const AKAMAI_PREFIX = {
    hm: 'https://image.hm.com/assets/hm',
    cos: 'https://images.cos.com/assets/001',
    otherStories: 'https://images.stories.com/assets/005',
    arket: 'https://www.arket.com/static-images/products/assets/006',
};
export const AKAMAI_DAM_PREFIX = {
    hm: 'https://image.hm.com',
    cos: 'https://images.cos.com',
    otherStories: 'https://images.stories.com',
    arket: 'https://images.arket.com',
};
//# sourceMappingURL=constants.js.map